import React, { useState } from "react";
import "./style.css";
import Typewriter from "react-simple-typewriter";
import "react-simple-typewriter/dist/index.css";
import studyMaterial from "../../assets/images/study_material.svg";
import { College_Section } from "../../components/CollegeSection";
import { Testimonials_Section } from "../../components/Testimonials_section";
import Particles from "react-particles-js";
function HomeScreen() {
  const [particles, setParticles] = useState(5);
  const checkResize = () => {
    if (window.innerWidth > 1100) {
      setParticles(60);
    } else if (window.innerWidth > 700) {
      setParticles(40);
    } else if (window.innerWidth > 600) {
      setParticles(20);
    } else if (window.innerWidth > 550) {
      setParticles(15);
    } else if (window.innerWidth > 500) {
      setParticles(11);
    } else if (window.innerWidth > 450) {
      setParticles(8);
    } else {
      setParticles(5);
    }
  };
  window.addEventListener(
    "load",
    function () {
      checkResize();
    },
    true
  );
  window.addEventListener(
    "resize",
    function () {
      checkResize();
    },
    true
  );

  return (
    <React.Fragment>
      <div className="home-page flex ai-c jc-c" id="home-page">
        <div id="particles-js">
          <Particles
            params={{
              particles: {
                number: {
                  value: particles,
                },
                size: {
                  value: 3,
                },
              },
              interactivity: {
                events: {
                  onhover: {
                    enable: true,
                    mode: "grab",
                  },
                  resize: true,
                },
                modes: {
                  grab: {
                    distance: 150.7962037962038,
                    line_linked: {
                      opacity: 1,
                    },
                  },
                },
              },
            }}
          />
        </div>
        <div className="container">
          <h3 className="text-white-accent text-center title  fw-400">
            Welcome to CSIT Mantra
          </h3>
          <p className="sub-text text-white-accent text-center my-2">
            We Provide
            <span className="mx-2 fw-600">
              <Typewriter
                loop
                cursor
                cursorStyle="|"
                typeSpeed={80}
                deleteSpeed={30}
                delaySpeed={1000}
                words={[
                  "Notes",
                  "Text Books",
                  "Model Question",
                  "Laboratory Work",
                  "Syllabus",
                  "Assignment",
                  "College Question",
                  "Notice",
                ]}
              />
            </span>
            of every semester of Bsc.CSIT.
          </p>
          <div className="home-action-buttons flex mt-4 jc-c">
            <span>
              <button className="btn btn-lg btn-green fw-500">
                Contact Us
              </button>
            </span>
            <span className="ml-3">
              <button className="btn btn-lg btn-blue-o fw-500">
                About our team
              </button>
            </span>
          </div>
        </div>
      </div>
      <div className="divider"></div>
      <div className="container services-section">
        <div className="services mt-5 py-4">
          <h1 className="services-header section-title text-center fw-500">
            Our Services
          </h1>
          <div className="grid mt-5 py-3 grid-3 gap-3">
            <div className="service-item blue p-2">
              <div className="flex ai-c">
                <div className="service-item-image-container flex jc-c ai-c p-2">
                  <img src={studyMaterial} alt="service-item-image" />
                </div>
                <div className="service-item-title ml-2">
                  <h2 className="fw-500">Study Material</h2>
                </div>
              </div>
              <p className="service-item-text mt-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse et
                possimus eligendi nihil sapiente dolorum sit reiciendis aut,
                velit consequuntur?
              </p>
            </div>
            <div className="service-item green p-2">
              <div className="flex ai-c">
                <div className="service-item-image-container flex jc-c ai-c p-2">
                  <img src={studyMaterial} alt="service-item-image" />
                </div>
                <div className="service-item-title ml-2">
                  <h2 className="fw-500">Entrance Material</h2>
                </div>
              </div>
              <p className="service-item-text mt-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse et
                possimus eligendi nihil sapiente dolorum sit reiciendis aut,
                velit consequuntur?
              </p>
            </div>
            <div className="service-item red p-2">
              <div className="flex ai-c">
                <div className="service-item-image-container flex jc-c ai-c p-2">
                  <img src={studyMaterial} alt="service-item-image" />
                </div>
                <div className="service-item-title ml-2">
                  <h2 className="fw-500">Latest Notice & Blogs</h2>
                </div>
              </div>
              <p className="service-item-text mt-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse et
                possimus eligendi nihil sapiente dolorum sit reiciendis aut,
                velit consequuntur?
              </p>
            </div>
            <div className="service-item blue p-2">
              <div className="flex ai-c">
                <div className="service-item-image-container flex jc-c ai-c p-2">
                  <img src={studyMaterial} alt="service-item-image" />
                </div>
                <div className="service-item-title ml-2">
                  <h2 className="fw-500">Study Material</h2>
                </div>
              </div>
              <p className="service-item-text mt-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse et
                possimus eligendi nihil sapiente dolorum sit reiciendis aut,
                velit consequuntur?
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="divider"></div>
      <College_Section />

      <Testimonials_Section
        items={[
          {
            id: 1,
            name: "Ram Limbu",
            text:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui voluptates facilis minus! A, dicta nobis natus dolorem dignissimos voluptate. Alias quis odit autem atque sapiente inventore provident laudantium officiis assumenda!",
          },
          {
            id: 2,
            name: "Ram Gurung",
            text: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
          },
          {
            id: 3,
            pic: "./csit_colleges/ascol.jpg",
            name: "Raj Limbu",
            text:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui voluptates facilis minus! A, dicta nobis natus dolorem dignissimos voluptate. Alias quis odit autem atque sapiente inventore provident laudantium officiis assumenda!",
          },
          {
            id: 4,
            name: "Naresh Poudel",
            text:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui voluptates facilis minus! A, dicta nobis natus dolorem dignissimos voluptate. Alias quis odit autem atque sapiente inventore provident laudantium officiis assumenda!",
          },
          {
            id: 5,
            name: "Jagat Ghale",
            pic: "./csit_colleges/ascol.jpg",
            text:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui voluptates facilis minus! A, dicta nobis natus dolorem dignissimos voluptate. Alias quis odit autem atque sapiente inventore provident laudantium officiis assumenda!",
          },
          {
            id: 6,
            name: "Sharad Mukarung",
            text:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui voluptates facilis minus! A, dicta nobis natus dolorem dignissimos voluptate. Alias quis odit autem atque sapiente inventore provident laudantium officiis assumenda!",
          },
          {
            id: 7,
            name: "Roman Joshi",
            text:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui voluptates facilis minus! A, dicta nobis natus dolorem dignissimos voluptate. Alias quis odit autem atque sapiente inventore provident laudantium officiis assumenda!",
          },
        ]}
      />
    </React.Fragment>
  );
}

export default HomeScreen;
